import { useState } from 'react'
import styled from 'styled-components'
import { GeckoFeaturesJSON } from 'types'

import { ApplyButton } from './ComponentTemplateItem'

const FeatureItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.625rem;
  align-items: center;
`

interface FeatureTemplateItemProps {
  feature: GeckoFeaturesJSON
  selectedComponentFeatures: (string | undefined)[]
  removeFeatures: (features: GeckoFeaturesJSON[]) => void
  applyFeatures: (features: GeckoFeaturesJSON[]) => void
}

export const FeatureTemplateItem = ({
  feature,
  selectedComponentFeatures,
  removeFeatures,
  applyFeatures,
}: FeatureTemplateItemProps) => {
  const isApplied = !!selectedComponentFeatures.find(
    (value) => value === feature.name
  )
  const [applyHovered, setApplyHovered] = useState(false)
  return feature.name ? (
    <FeatureItem key={feature.name}>
      <ApplyButton
        style={{ width: '1.5rem' }}
        onClick={() =>
          isApplied ? removeFeatures([feature]) : applyFeatures([feature])
        }
        onMouseEnter={() => setApplyHovered(true)}
        onMouseLeave={() => setApplyHovered(false)}
        $isApplied={isApplied}>
        {isApplied ? (applyHovered ? ' - ' : '✓') : '+'}
      </ApplyButton>
      <div>
        {feature.name} ({feature.type})
      </div>
    </FeatureItem>
  ) : null
}
